import React from 'react';
import { Simplify } from 'type-fest';
import { Dashboard } from './Dashboard';
import { formatSupersetDate } from '../../helpers/dates';

export type ApprovedTasks = {
  params: {
    dateCreated: string;
    phone: string;
  };
};

type ApprovedTasksDashboardProps = ApprovedTasks['params'] & {
  brandId: number;
  id: string;
};

function ApprovedTasksDashboard(props: ApprovedTasksDashboardProps) {
  const { brandId, dateCreated, phone, id } = props;

  return (
    <Dashboard
      id={id}
      dashboardUiConfig={{
        urlParams: {
          phone_number: phone,
          local_date: formatSupersetDate(new Date(dateCreated)),
          brand_id: brandId,
        },
        hideTitle: true,
        hideTab: true,
        hideChartControls: true,
        filters: {
          visible: false,
          expanded: false,
        },
      }}
    />
  );
}

function createApprovedTasksDashboard(id: string) {
  type ApprovedTasksDashboardSpecificProps = Simplify<
    Omit<ApprovedTasksDashboardProps, 'id'>
  >;

  return function ApprovedTasksDashboardCO(
    props: ApprovedTasksDashboardSpecificProps,
  ) {
    return <ApprovedTasksDashboard {...props} id={id} />;
  };
}

export const ApprovedTasksDashboardCO = createApprovedTasksDashboard(
  '24120470-b519-40fd-8bb9-37528f32512d',
);

export const ApprovedTasksDashboardMX = createApprovedTasksDashboard(
  '4f7178ab-4878-44cc-8e51-3a458db49ca3',
);

export const ApprovedTasksDashboardBR25 = createApprovedTasksDashboard(
  '5755ddd2-bd7b-4fca-957d-bd93e6b32d0b',
);

export const ApprovedTasksDashboardBR30 = createApprovedTasksDashboard(
  '7b6d7a22-577a-467b-9286-89a5efb56ce8',
);

export const ApprovedTasksDashboardBR35 = createApprovedTasksDashboard(
  'bafccfa1-3e1f-49de-962e-0a7d41557765',
);

export const ApprovedTasksDashboardBR40 = createApprovedTasksDashboard(
  '4d077c69-5351-49f8-a592-9dec72e64ba4', // only in supersest-io 'dd34c281-52f6-4a24-87d5-72aa030cf6cb'
);
